import PazienteParametriVitaliPage from "./pages/PazienteParametriVitaliPage.vue";

export default {
    PazienteParametriVitaliPage,
};
